import { EnvironmentProviders, inject, provideAppInitializer } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom, map } from 'rxjs';
import { ConfigService } from './config.service';

/**
 * Loads the app config from the given URI before the app starts and puts it into
 * {@link ConfigService}. Services read their backend URLs from there — see `BackendUrlConfig`.
 */
export const provideConfigFromUri = <T>(uri: string): EnvironmentProviders => {
  return provideAppInitializer(() => {
    const http = inject(HttpClient);
    const configService = inject(ConfigService<T>);
    const config$ = http.get<T>(uri).pipe(
      map((config) => {
        return (configService.config = config);
      }),
    );
    return lastValueFrom(config$);
  });
};

/**
 * Puts an already known config into {@link ConfigService} — for tests and for apps that don't
 * fetch their config at runtime.
 */
export const provideStaticConfig = <T>(config: T): EnvironmentProviders => {
  return provideAppInitializer(() => {
    const configService = inject(ConfigService<T>);
    configService.config = config;
  });
};
